/**
 * 微博授权
 */
import { cbHost } from '../config';
import Url from 'c-url';
import Cache from 'c-cache';
import notification from 'c-notification';
import lang from '../../../lang';

const cache = new Cache({
    prefix: 'pcuplive'
});

const Transfer = {
    go(type) {
        let urlPrefix = 'https://h5.upliveapp.com/uplive-login/index.html';
        let result = {
            'multiLoginChannel':1,
            'target_uri': this.getTransferUrl('/transfer.html?oauthback=5'),
            'oauthtype': type,
            'env': Url.query('env') ? Url.query('env') : 'pro',
            'channel': UP.Global.channel,
            'ignoreCountryCode': 1,
            'display':  'pcweb'
        };
        
        let url = urlPrefix + '?' + $.param(result);

        UP.PrepaireForAsync({ message: lang.template('请稍侯，正在登录中...') });

        let weiboWindow = window.open(url);

        let promise = UP.WaitForRecieveMsg(weiboWindow, 'h5login', type);

        promise.done((__user) => {
            let user = decodeURIComponent(__user);
            const { userToken, uid } = JSON.parse(user);
            
            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            fbq('track', 'LoginSuccess', { oauthtype: type});

            UP.Global.DA.add({
                eventName: type + 'LoginSuccess',
                action: 'click'
            });

            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            $.channel.emit('authSuccess', {
                userToken,
                uid
            })
        });

        promise.fail(()=>{
            notification.simple(lang.template('授权失败'));
        });
    },

    getTransferUrl: function(url) {
        let pathname = '';
        
        if (location.pathname.indexOf('/uplive-pc/') > -1) {
            pathname = location.pathname.substr(0, location.pathname.indexOf('/uplive-pc/') + '/uplive-pc/'.length - 1)
        }

        return location.protocol + '//' + location.hostname + pathname + url;
    }
};

export default Transfer;



// WEBPACK FOOTER //
// ./js/component/thirdparty-login/transfer/index.js